export default function poscreditInit() {
  return {
    event: 'web_bnpl_poscredit',
  }
}
